var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext } from "react";
import styled, { css } from "styled-components";
import { layoutGridMixins } from "./layoutGridMixins";
import { safeElement, breakPointArrayCleaner, responsiveArraySpreader } from "../../utils";
import { LayoutGridContext } from "./LayoutGridContext";
import { globalStyleMixins } from "../../globalStyleMixins";

var LayoutGridCell = function LayoutGridCell(_ref) {
  var children = _ref.children,
      _ref$span = _ref.span,
      span = _ref$span === undefined ? 1 : _ref$span,
      _ref$order = _ref.order,
      order = _ref$order === undefined ? 1 : _ref$order,
      _ref$hide = _ref.hide,
      hide = _ref$hide === undefined ? false : _ref$hide,
      _ref$spanMarginLeft = _ref.spanMarginLeft,
      spanMarginLeft = _ref$spanMarginLeft === undefined ? false : _ref$spanMarginLeft,
      _ref$addPaddingLeft = _ref.addPaddingLeft,
      addPaddingLeft = _ref$addPaddingLeft === undefined ? false : _ref$addPaddingLeft,
      _ref$spanMarginRight = _ref.spanMarginRight,
      spanMarginRight = _ref$spanMarginRight === undefined ? false : _ref$spanMarginRight,
      _ref$addPaddingRight = _ref.addPaddingRight,
      addPaddingRight = _ref$addPaddingRight === undefined ? false : _ref$addPaddingRight,
      restProps = _objectWithoutProperties(_ref, ["children", "span", "order", "hide", "spanMarginLeft", "addPaddingLeft", "spanMarginRight", "addPaddingRight"]);

  var _useContext = useContext(LayoutGridContext),
      base = _useContext.base,
      gapArray = _useContext.gapArray,
      wrapped = _useContext.wrapped;

  var spanArray = breakPointArrayCleaner(span);
  var orderArray = breakPointArrayCleaner(order);
  var hideArray = breakPointArrayCleaner(hide);
  var spanMarginLeftArray = breakPointArrayCleaner(spanMarginLeft);
  var addPaddingLeftArray = breakPointArrayCleaner(addPaddingLeft);
  var spanMarginRightArray = breakPointArrayCleaner(spanMarginRight);
  var addPaddingRightArray = breakPointArrayCleaner(addPaddingRight);

  return React.createElement(
    CellStyled,
    _extends({
      gapArray: gapArray,
      wrapped: wrapped,
      spanArray: spanArray,
      spanMarginLeftArray: spanMarginLeftArray,
      addPaddingLeftArray: addPaddingLeftArray,
      spanMarginRightArray: spanMarginRightArray,
      addPaddingRightArray: addPaddingRightArray,
      orderArray: orderArray,
      hideArray: hideArray
    }, restProps),
    children
  );
};

export { LayoutGridCell };
var CellStyled = styled(safeElement()).withConfig({
  displayName: "LayoutGridCell__CellStyled",
  componentId: "fgdgt8-0"
})(["", " ", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return responsiveArraySpreader(function (value) {
    return css(["grid-column:span ", ";"], value);
  }, props.spanArray);
}, function (props) {
  return responsiveArraySpreader(function (value) {
    return css(["order:", ";"], value);
  }, props.orderArray);
}, globalStyleMixins.background, globalStyleMixins.softRightCorner, globalStyleMixins.verticalSpace, layoutGridMixins.gridPositioning, layoutGridMixins.gridSpanSpaceVertical, function (props) {
  return responsiveArraySpreader(function (value) {
    return css(["display:", ";"], value ? "none" : "static");
  }, props.hideArray);
});